import React from "react";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH} from "modules";
import styled from "styled-components";
import desktopBg from "apps/DRAW_PREDICTOR/assets/images/predraw/desktopTooltip.png";
import mobileBg from "apps/DRAW_PREDICTOR/assets/images/predraw/mobileTooltip.png";
import {media} from "assets/css/media";
import {ReactComponent as CloseIcon} from "assets/images/icons/closeWhite.svg";
import {PureButton} from "components";

const Wrapper = styled.div`
	background: url(${desktopBg});
	background-size: cover;
	position: absolute;
	min-width: 364px;
	min-height: 151px;
	right: 35px;
	bottom: -40px;
	display: flex;
	align-items: center;
	justify-content: center;

	color: #ffffff;
	p {
		max-width: 80%;
		padding: 20px;
		font-family: "Graphik";
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 160%;
	}
	@media (max-width: ${media.mobile}) {
		background: url(${mobileBg});
		min-width: 335px;
		min-height: 151px;
		right: 0;
		bottom: auto;
		z-index: 5;
		top: 40px;
	}
`;

const CloseButton = styled(PureButton)`
	position: absolute;
	right: 50px;
	top: 20px;
	@media (max-width: ${media.mobile}) {
		right: 10px;
		top: 40px;
	}
`;

interface IProps {
	tooltip?: string;
	onClick: () => void;
}

export const Tooltip: React.FC<IProps> = ({tooltip, onClick}) => {
	const {t} = useTranslation(LANGUAGE_PATH);
	if (!tooltip) {
		return null;
	}

	return (
		<Wrapper>
			<CloseButton onClick={onClick}>
				<CloseIcon />
			</CloseButton>
			<p>{t(tooltip)}</p>
		</Wrapper>
	);
};
